exports.createdStores = [];

exports.createdActions = [];

exports.reset = function() {
    while(exports.createdStores.length) {
        exports.createdStores.pop();
    }
    while(exports.createdActions.length) {
        exports.createdActions.pop();
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/reflux/src/Keep.js
 ** module id = 228
 ** module chunks = 0
 **/